import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseApi, RequestType } from '@kapi';
import { EnvironmentVariablesService } from '@kenv';
import { Traits } from '@kp/traits/traits.model';
import { DataStoreService } from '@kservice';
import { Observable, firstValueFrom, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class TraitsApi extends BaseApi {
  constructor(
    private _client: HttpClient,
    public dataStoreService: DataStoreService,
    private _environmentVariablesService: EnvironmentVariablesService
  ) {
    super(_client, dataStoreService, _environmentVariablesService);
  }

  async getTraits(): Promise<Traits> {
    const url = this.buildUrl('/traits', true);
    const request$ = this.performRequest<Traits>(RequestType.GET, url, { includeToken: true }).pipe(
      map((response: HttpResponse<Traits>): Traits => {
        if (response && response.ok) {
          return new Traits().deserialize(response.body);
        }
        return null;
      }),
      catchError((error): Observable<Traits> => {
        console.warn('Failed getting user traits: ', error);
        return of(new Traits(null));
      })
    );
    return firstValueFrom(request$).catch((error) => {
      console.warn('Error getting user traits: ', error);
      return null;
    });
  }
}
